import React from 'react'
import { HasLoaded, NavList } from 'easyguide'
import { string, arrayOf, bool, object } from 'prop-types'
import { Wrapper } from './Sidebar.style'

const Sidebar = ({ className, items, isLoading }) => (
  <Wrapper className={className}>
    <HasLoaded isLoaded={!isLoading}>
      <NavList items={items} />
    </HasLoaded>
  </Wrapper>
)

Sidebar.propTypes = {
  className: string.isRequired,
  items: arrayOf(object).isRequired,
  isLoading: bool.isRequired
}

export default Sidebar
